import { ref } from 'vue';
import {
    parseWeekBydate,
    parseMonthBydate,
    getMinOrMaxDateBylist,
    diffBetweenDates,
    compareTime
} from "@/views/rdmanagement/components/customGantt/serve/index";
import { getBarColor, rowSideLength } from "@/views/rdmanagement/components/customGantt/serve/options";

export const getMinMaxDates = (list) => {
    const rowList = [];

    let startTime = null;
    let endTime = null;

    list.forEach((item) => {
        const {
            actualReleaseEndTime,
            actualReleaseStartTime,
            releaseEndTime,
            releaseStartTime,
            scheduledEndTime,
            scheduledStartTime,
            taskName,
            completionDegree,
        } = item;

        const currentStartTime = getMinOrMaxDateBylist(
            [scheduledStartTime, releaseStartTime, actualReleaseStartTime],
            "min"
        );

        const currentEndTime = getMinOrMaxDateBylist(
            [scheduledEndTime, releaseEndTime, actualReleaseEndTime],
            "max"
        );

        startTime = compareTime(startTime, currentStartTime, 'min');
        endTime = compareTime(endTime, currentEndTime, 'max');

        const releaseTask = {
            startTime: releaseStartTime,
            endTime: releaseEndTime,
            ifShow: Boolean(releaseStartTime && releaseEndTime),
            type: "release",
            taskName,
            completionDegree,
            scheduledStartTime,
            scheduledEndTime,
            actualReleaseStartTime,
            actualReleaseEndTime,
        };

        const actualReleaseTask = {
            startTime: actualReleaseStartTime,
            endTime: actualReleaseEndTime,
            ifShow: Boolean(actualReleaseStartTime && actualReleaseEndTime),
            type: "actualRelease",
        };

        // 任务超时设置超时
        actualReleaseTask.type =
            actualReleaseTask.ifShow &&
                actualReleaseTask.endTime > releaseTask.scheduledEndTime
                ? "timeout"
                : "actualRelease";

        rowList.push(
            releaseTask,
            {
                startTime: scheduledStartTime,
                endTime: scheduledEndTime,
                ifShow: Boolean(scheduledStartTime && scheduledEndTime),
                type: "scheduled",
            },
            actualReleaseTask
        );
    });

    return { startTime, endTime, rowList };
};

export const getTaskInfo = (options, mode) => {
    const { year, startMonth, startTime, endTime } = options;


    let taskLeft = null;
    let taskWidth = null;

    switch (mode) {
        case "day":
            taskLeft = diffBetweenDates(`${year}-${startMonth}-01`, startTime);
            taskWidth = diffBetweenDates(startTime, endTime);
            break;
        case "week":
            taskLeft = parseWeekBydate(`${year}-${startMonth}-01`, startTime, 'left');
            taskWidth = parseWeekBydate(startTime, endTime, 'width');
            break;
        case "month":
            taskLeft = parseMonthBydate(`${year}-${startMonth}-01`, startTime, 'left');
            taskWidth = parseMonthBydate(startTime, endTime, 'width');
            break;
        default:
            break;
    }

    return { taskLeft, taskWidth };
};


export const gantt = ref();

/**
 * 删除具有data-type属性为progress-time的元素
 * */
export const deleteProgressTime = () => {
    const nodeList = document.querySelectorAll('[data-type="progress-time"]');

    // 删除该元素
    if (nodeList.length > 0) {
        Array.from(nodeList).forEach((dom) => {
            if (dom && dom.parentNode) {
                dom.parentNode.removeChild(dom);
            }
        });
    }
};

/**
 * 任务范围
 */
export const renderProgressTime = (positionInfo, record) => {
    const { left, width, top } = positionInfo;
    const { type } = record;

    const childElement = document.createElement("div");
    childElement.style.width = `${width}px`;
    childElement.style.height = `${rowSideLength / 1.5}px`;
    childElement.style.left = `${left}px`;
    childElement.style.top = `${top}px`;
    childElement.style.position = "absolute";
    childElement.setAttribute("data-type", "progress-time");

    childElement.style.backgroundColor = getBarColor(type);

    gantt.value.appendChild(childElement);
};

/**
 * 假期范围
 */
export const renderWeekendTime = (positionInfo) => {
    const { left, width, top, height } = positionInfo;
    const childElement = document.createElement("div");
    childElement.style.width = `${width}px`;
    childElement.style.height = `${height}px`;
    childElement.style.left = `${left}px`;
    childElement.style.top = `${top}px`;
    childElement.style.position = "absolute";
    childElement.style.zIndex = 1;
    childElement.setAttribute("data-type", "progress-time");

    childElement.style.backgroundColor = '#f0f0f0';

    gantt.value.appendChild(childElement);
};

/**
 * 透明任务范围
 * @params {string} options.positionInfo left width top
 * @params {function} options.updateTaskInfo task update function
 * @params {function} options.hideTaskInfo task hide function
 * @params {function} options.showTaskInfo task show function
 */
export const rednerRecordInfoDom = (options, record) => {
    const { positionInfo, updateTaskInfo, hideTaskInfo, showTaskInfo } = options;
    const { left, width, top } = positionInfo;
    const childElement = document.createElement("div");
    childElement.style.width = `${width}px`;
    childElement.style.height = `${rowSideLength * 3}px`;
    childElement.style.left = `${left}px`;
    childElement.style.top = `${top}px`;
    childElement.style.position = "absolute";
    childElement.style.cursor = "pointer";
    childElement.style.zIndex = "2";
    childElement.setAttribute("data-type", "progress-time");
    childElement.setAttribute("data-record", JSON.stringify(record));
    childElement.addEventListener("mousemove", updateTaskInfo);
    childElement.addEventListener("mouseleave", hideTaskInfo);
    childElement.addEventListener("mouseenter", showTaskInfo);
    gantt.value.appendChild(childElement);
};
